export default function About() {
  return (
    <div>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary-color) 0%, #0052a3 100%)',
        color: 'white',
        padding: '40px 28px',
        borderRadius: '12px',
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          margin: '0 0 12px 0',
          lineHeight: '1.2'
        }}>
          About Our Program
        </h1>
        <p style={{
          fontSize: '16px',
          margin: 0,
          opacity: '0.95'
        }}>
          Understanding our mission and impact
        </p>
      </div>

      {/* Mission Section */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          marginBottom: '16px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <i className="ti ti-target" style={{ color: 'var(--primary-color)', fontSize: '24px' }} aria-hidden="true"></i>
          Our Mission
        </h2>
        <p style={{
          color: 'var(--text-secondary)',
          lineHeight: '1.8',
          fontSize: '15px',
          margin: 0
        }}>
          Our mission is to reduce poverty and improve living standards for vulnerable populations. Through regular, predictable cash transfers, we enable families and entrepreneurs to meet their basic needs and grow their businesses. We believe that every person deserves the opportunity to build a better future.
        </p>
      </div>

      {/* Who We Serve */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          marginBottom: '20px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <i className="ti ti-users" style={{ color: '#10b981', fontSize: '24px' }} aria-hidden="true"></i>
          Who We Serve
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '16px'
        }}>
          {[
            { icon: 'ti-users', title: 'Youth Entrepreneurs', desc: 'Ages 18-35 building their businesses' },
            { icon: 'ti-user', title: 'Women Entrepreneurs', desc: 'Supporting women in business and commerce' },
            { icon: 'ti-accessibility', title: 'Persons with Disabilities', desc: 'Enabling economic participation for all' },
            { icon: 'ti-home', title: 'Vulnerable Families', desc: 'Supporting households in need' }
          ].map((item, idx) => (
            <div key={idx} style={{
              padding: '20px',
              background: 'var(--bg-light)',
              borderRadius: '10px',
              border: '1px solid var(--border-light)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <i className={`ti ${item.icon}`} style={{
                fontSize: '28px',
                color: 'var(--primary-color)',
                marginBottom: '12px',
                display: 'block'
              }} aria-hidden="true"></i>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '8px',
                color: 'var(--text-dark)',
                margin: '0 0 8px 0'
              }}>
                {item.title}
              </h3>
              <p style={{
                fontSize: '13px',
                color: 'var(--text-light)',
                margin: 0,
                lineHeight: '1.6'
              }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Impact Section */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          marginBottom: '16px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <i className="ti ti-chart-bar" style={{ color: '#f59e0b', fontSize: '24px' }} aria-hidden="true"></i>
          Our Impact
        </h2>
        <p style={{
          color: 'var(--text-secondary)',
          lineHeight: '1.8',
          fontSize: '15px',
          marginBottom: '16px',
          margin: 0
        }}>
          The program has demonstrated significant positive outcomes including:
        </p>
        <ul style={{
          paddingLeft: '24px',
          color: 'var(--text-secondary)',
          lineHeight: '2',
          fontSize: '14px'
        }}>
          <li>Increased food consumption and dietary diversity</li>
          <li>Improved access to quality healthcare and education</li>
          <li>Enhanced economic activity at household level</li>
          <li>Better living conditions and reduced poverty</li>
          <li>Increased entrepreneurship and business growth</li>
          <li>Strengthened community resilience</li>
        </ul>
      </div>

      {/* Values Section */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary-color) 0%, #0052a3 100%)',
        color: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0, 102, 204, 0.2)'
      }}>
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          marginBottom: '24px',
          textAlign: 'center'
        }}>
          Our Core Values
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '20px'
        }}>
          {[
            { icon: 'ti-heart', title: 'Compassion', desc: 'Caring for vulnerable populations' },
            { icon: 'ti-shield-check', title: 'Integrity', desc: 'Transparent and honest operations' },
            { icon: 'ti-users-group', title: 'Inclusion', desc: 'No one left behind' },
            { icon: 'ti-bulb', title: 'Innovation', desc: 'Improving lives through technology' }
          ].map((item, idx) => (
            <div key={idx} style={{
              textAlign: 'center'
            }}>
              <i className={`ti ${item.icon}`} style={{
                fontSize: '32px',
                marginBottom: '12px',
                display: 'block',
                opacity: '0.9'
              }} aria-hidden="true"></i>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '6px',
                margin: '0 0 6px 0'
              }}>
                {item.title}
              </h3>
              <p style={{
                fontSize: '13px',
                margin: 0,
                opacity: '0.9'
              }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

